import { Component, HostListener, OnInit, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { RestService } from '@services/rest.service';
import { Card } from '@models/post-login.model';
import { MessageBusService } from '@services/message-bus/message-bus.service';
import { AlertChangeEvent, SelectedCardEvent } from '@services/message-bus/message-bus-events';
import { DashboardService } from './../../../pages/dashboard/dashboard.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PostLoginResponseEvent } from '@services/message-bus/message-bus-events';
import { AppConfiguration } from '@config/app-configuration';
import { WarningsComponent } from '@common/warnings/warnings.component';
import { OldWebsiteComponent } from '@common/old-website/old-website.component';
import { TranslateService } from '@ngx-translate/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { AnalyticsService } from '@services/analytics.service';
import { GlobalService } from '@services/global.service';
import { SmioneIntroScreensComponent } from '@common/carousels/carousels.component';
@Component({
  selector: 'smione-smione-header',
  templateUrl: './smione-header.component.html',
  styleUrls: ['./smione-header.component.scss']
})
export class SmioneHeaderComponent implements OnInit {

  AllowPayPerks:boolean = false;
  public selectedCard: Card = {} as Card;
  IsNewWebsiteAvailable : boolean = false;
  screenHeight: number;
  screenWidth: number;
  classNavmenu:boolean = false;
  public toggleField() {
    this.analyticsService.gtag(this.componentName, 'toggleField');
    this.classNavmenu = !this.classNavmenu; 
  }
  cardsBtn: boolean = false;
  subscription: any;
  alerts :any;
  unreadCount :number = 0;
  showSavings :boolean = false;
  showMyContainer: boolean = false;
  menuOpen: boolean = false;
  menuBtnClick: boolean = false;
  isPopUpOpen :boolean = false;
  public cards;
  @ViewChild('menuTrigger') matMenuTrigger: MatMenuTrigger;
  @ViewChild('notifyDropdown') notifyDropdown: ElementRef<HTMLElement>;
  componentName : string = 'SmioneHeader';
  private hrefRouteMap: { [key: string]: { pathName: string; route: string } } = {
    'DDA': { pathName: 'directdeposit', route: '/smione/manage' },
    'CARD_SERVICES': { pathName: 'managecards', route: '/smione/manage' }
  };
  shippingData;
  navDetails = {
    currentStep: "" 
  };
  showAlternateIntroPop: boolean = false; 
  smioneLoginRestrictmodalTrue: boolean = false; 
  isSkipUpgradeKudzu: boolean = false; 
  UpgradeKudzu: boolean = false;
  ShowCarousel: boolean = false;
  ShowPopup: boolean = false
  ShowWidget: boolean = false 
  IsActivateCardNewFlowEnabled : boolean = false
  constructor(
    private appConfig: AppConfiguration,
    private router: Router,
    private restService: RestService, 
    public messageBus: MessageBusService,
    private dashboardService: DashboardService,
    private dialog: MatDialog,
    private renderer: Renderer2,
    public dialogRef: MatDialogRef<OldWebsiteComponent>,
    public translate: TranslateService,
    private analyticsService: AnalyticsService,
    private globalService: GlobalService
  ) { 
    this.restService.menuEmitter.subscribe(this.toggleCardsMenu.bind(this));   
    this.renderer.listen('window', 'click', (e: Event) => {

      if(this.screenWidth<769){      
        if (!this.menuBtnClick) {
          this.menuOpen = false;
        }
        this.menuBtnClick = false;
      }

      else{ this.menuOpen = true;}

    });
    this.messageBus.on(SelectedCardEvent, (event) => {  
      this.selectedCard = event.payload;
      this.AllowPayPerks = this.selectedCard.AllowPayPerks;      
      this.IsNewWebsiteAvailable = this.selectedCard.IsNewWebsiteAvailable;  
      //this.IsNewWebsiteAvailable  = true; 
    });
 
    if(this.selectedCard && this.selectedCard.CardKey){
      this.getAlerts(this.selectedCard.CardKey);
    }
    this.subscription = this.messageBus.getCard()
    .subscribe(item => this.selecteCardValue(item));    
    if (this.selectedCard.AllowSavings) {
      this.messageBus.on(PostLoginResponseEvent, (event) => {
        const savingCards = event.payload.Cards.filter(f => f.AccountTypeBit63 === 32);
        if (savingCards && savingCards.length) { this.showSavings = true; }
        else { this.showSavings = false; }
      });
    }
    this.restService.getReloadAlertsStatus().subscribe(status=>{
      if(status){
        this.getAlerts(this.selectedCard.CardKey);
      }
    })
    this.getScreenSize();  
  }

  openMenu(event: MouseEvent, viewChild: MatMenuTrigger) {
    //event.preventDefault();
    viewChild.openMenu();
  }

  @HostListener('window:resize', ['$event'])

  getScreenSize(event?) {   
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        if(this.screenWidth>768)
          this.menuOpen = true;
        else
          this.menuOpen = false;
  }

  toggleMenu() {
    this.analyticsService.gtag(this.componentName, 'toggleMenu');
    this.menuOpen = !this.menuOpen;
  }

  preventCloseOnClick() {
    this.analyticsService.gtag(this.componentName, 'preventCloseOnClick');
    this.menuBtnClick = true;
  }

  toggleCardsMenu(){
    this.matMenuTrigger.openMenu();
  }

  getExternalSVAIDsFromCookies(): string[] {
    const cookieString = document.cookie
        .split('; ')
        .find(cookie => cookie.startsWith('ExternalSVAIDs='));

    try {
        return cookieString 
            ? JSON.parse(decodeURIComponent(cookieString.split('=')[1])) 
            : [];
    } catch (error) {
        console.error('Error parsing ExternalSVAIDs from cookies:', error);
        return [];
    }
}

getDarkModalExternalSVAIDsFromCookies(): string[] {
    const cookieString = document.cookie
        .split('; ')
        .find(cookie => cookie.startsWith('DarkModalExternalSVAIDs='));

    try {
        return cookieString 
            ? JSON.parse(decodeURIComponent(cookieString.split('=')[1])) 
            : [];
    } catch (error) {
        console.error('Error parsing DarkExternalSVAIDs from cookies:', error);
        return [];
    }
}

checkExternalSVAIDExists(externalSVAID: string): boolean {
    const existingSVAIDs = this.getExternalSVAIDsFromCookies();
    return existingSVAIDs.includes(externalSVAID);
}

checkDarkModalSVAIDExists(externalSVAID: string): boolean {
    const existingSVAIDs = this.getDarkModalExternalSVAIDsFromCookies();
    return existingSVAIDs.includes(externalSVAID);
}


  

  ngOnInit() {
    const data = localStorage.getItem('data');
    const svaidFromSession = sessionStorage.getItem('ExternalSVAIDForSession');
    const darkModalSVAIDFromSession = sessionStorage.getItem('ExternalSVAIDForSessionDarkModal');
    this.getMigrationDetailsAPICall()
   
    
    $(document).on("contextmenu", function () {
      //return false;
    }); 

    this.messageBus.on(PostLoginResponseEvent, (event) => { 
      this.cards = event.payload.Cards.filter(f => f.AccountTypeBit63 != 32); 
      this.IsActivateCardNewFlowEnabled = event.payload.IsActivateCardNewFlowEnabled;     
    });
    this.messageBus.on(SelectedCardEvent, (event) => { 
      this.selectedCard = event.payload;       
     });
    this.restService.isAlertChange.subscribe(res => {
      let alertUnreadCount = JSON.parse(sessionStorage.getItem("alerts"));
      if(alertUnreadCount){
        this.unreadCount = alertUnreadCount.UnreadCount;
      }
    })
   
  }

  openModalOnLoad(showAlternateIntroPop, isSkipUpgradeKudzu ): void {
    const modalPanelClass = showAlternateIntroPop ? 'smione-intro-modal-alternate' : 'smione-intro-modal';
    this.dialog.open(SmioneIntroScreensComponent, {
      disableClose: true,
      panelClass: modalPanelClass,
      data:{
        showAlternateIntroPop: showAlternateIntroPop,
        isSkipUpgradeKudzu: isSkipUpgradeKudzu,
        smioneLoginRestrictmodalTrue:this.smioneLoginRestrictmodalTrue,
        cardKey:this.selectedCard.CardKey,
        isFromDashboard:false,
        slides: [
          {
            title: "<span class='smione-highlight-text' style='font-weight: 700; font-size: 22px'> Introducing </span> <span class='highlight-text' style='font-weight: 600;'>Kudzu</span>: Finally, Banking That’s On Your Side.",
            description: "<b>Kudzu is everything you like about smiONE—with smarter tools, budgeting tips, and no credit checks or overdraft fees*. Make the switch in minutes. Your smiONE account moves with you.</b>",
            bottomText: `Kudzu is a financial technology company, not a bank. Banking services provided by The Bancorp Bank, N.A., Member FDIC.*Other fees and limits apply. See the <a class="carousel-bottom-link" href="https://kudzumoney.com/policies/#kudzu-deposit-account-agreement" target="_blank" rel="noopener noreferrer">Deposit Account Agreement</a> for details.`,
            image: "assets/images/intro-images/smi-intro-1.png", 
          }, 
          {
            title: "<span class='highlight-text' style='font-weight: 700;'>Kudzu</span> helps you take control of your finances.",
            description: "<b>When you switch to Kudzu, you’ll open a Kudzu spending account (and optional interest-earning savings account!) to grow your financial skills with interactive tools. You’ll also get new self-service features, like updating your info right in the app.</b>",
            image: "assets/images/Smi_mobile.png"
          },
          {
            title: "<span class='smione-highlight-text' style='font-weight: 700;'>And, you can manage your smiONE Card account right in the <span class='highlight-text' style='font-weight: 700;'>Kudzu</span> app.</span>",
            description: "<span style='font-weight: 600;'><b>Adding your smiONE Card account to your new </b></span><span><b>Kudzu app takes only moments and lets you</b></span><b> access, view, and manage your money all in one</b><span><b> place.</b></span></span>",
            image: "assets/images/smi_mobile_image.png"
          },
          {
            title: "<span class='smione-highlight-text' style='font-weight: 700;'>We’ll transfer your smiONE Card account data over to<span class='highlight-text' style='font-weight: 700;'> Kudzu.</span></span>",
            description: "<b>Kudzu has everything you need—and more. Once you make the switch, you won’t be able to use the smiONE app anymore, but don’t worry—we’ll be with you every step of the way.</b>",
            image: "assets/images/intro-images/smi_intro_file.png"
          },
          {
            title: "<span class='smione-highlight-text' style='font-weight: 700;'>Nothing changes unless you want it to.</span>",
            description: "<b>You’ll continue to receive your regular deposits on your smiONE Card and you’ll be able to manage and spend your money as you normally would. You can choose to switch your deposits over to your new Kudzu spending account, or dedicate it to other funds.</b>",
            image: "assets/images/intro-images/smi-intro-dd-2.png"
          }
        ]}
    });
  }

  getCardDesign() {
    
    this.globalService.getCardDesign(this);

  }

  setCard(card:Card) {
    this.selectedCard = card;
    this.messageBus.emit(new SelectedCardEvent(card));
    this.messageBus.emitCard(card);  
  }

  selecteCardValue(card: Card) {   
    this.selectedCard = card;  
    this.AllowPayPerks = this.selectedCard.AllowPayPerks;   
    this.IsNewWebsiteAvailable = this.selectedCard.IsNewWebsiteAvailable; 
    this.getAlerts(card.CardKey);
   
    if(this.selectedCard.AllowSavings){ 
      this.messageBus.on(PostLoginResponseEvent, (event) => { 
        const savingCards = event.payload.Cards.filter(f => f.AccountTypeBit63 === 32);
        if(savingCards && savingCards.length){ this.showSavings = true; }
        else{ this.showSavings = false; }
      });
    }   
  }
 
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getAlerts(CardKey){
    if (sessionStorage.getItem("alerts") && sessionStorage.getItem("alerts")!="null")
    {
      var res = JSON.parse(sessionStorage.getItem("alerts"));
      if(res.card == this.selectedCard.CardKey)
      {
        this.alerts = res.Alerts;
        this.unreadCount = res.UnreadCount;
        let warnings = [];
        this.alerts['Items'].forEach((alert)=>{
          if(alert.Content)
            alert.Content = alert.Content.replace(/‑/g, '-');
          if(alert.AlertTypeCode == 'WRN' && alert.Unread){
            warnings.push(alert);
          }
        });
        if(warnings.length){ this.showWarings(warnings);
          this.getAlertsFromAPI(this.selectedCard.CardKey);
         }
      }
      else
        this.getAlertsFromAPI(CardKey);
    }
    else
    {
      this.getAlertsFromAPI(CardKey);
    }
  }

  getMigrationDetailsAPICall() {
    const cachedDetails = sessionStorage.getItem('KudzuMigrationDetails');
    if (cachedDetails) {
      const res = JSON.parse(cachedDetails);
      // Optionally show modal once per session based on cached response
      //const modalShown = sessionStorage.getItem('KudzuMigrationModalShown') === '1';
      return;
    }
    this.dashboardService.GetMigrationDetails().subscribe(
      (res) => {
        // NOTE: RestService.get() already maps to res.Response, so `res` here is the inner Response object
        if (res && res.UpgradeKudzu && res.ShowCarousel) {
          this.openModalOnLoad(res.ShowPopup, res.SkipUpgradeKudzu);
          sessionStorage.setItem('KudzuMigrationModalShown', '1');
        } else if (res.UpgradeKudzu && res.ShowPopup) {
          this.openModalOnLoad(res.ShowPopup, res.SkipUpgradeKudzu);
          sessionStorage.setItem('KudzuMigrationModalShown', '1');
        }
        // Cache response to avoid re-calling this API during the same session
        try { sessionStorage.setItem('KudzuMigrationDetails', JSON.stringify(res || {})); } catch { }
      },
      (error) => {
        console.error('GetMigrationDetails failed:', error);
      }
    )
  }




  getAlertsFromAPI(CardKey)
  {
    this.dashboardService.getAlerts(CardKey).subscribe(
      (res)=>{
        this.messageBus.emit(new AlertChangeEvent(JSON.stringify(res)));
        res.card = this.selectedCard.CardKey;
        sessionStorage.setItem("alerts", JSON.stringify(res));        
        this.alerts = res.Alerts;
        this.unreadCount = res.UnreadCount;
        let warnings = [];
        this.alerts['Items'].forEach((alert)=>{
          if(alert.Content)
            alert.Content = alert.Content.replace(/‑/g, '-');
          if(alert.AlertTypeCode == 'WRN' && alert.Unread){
            warnings.push(alert);
          }
        });
        if(warnings.length){ this.showWarings(warnings);
          // alert()
          // this.getAlertsFromAPI(this.selectedCard.CardKey);
         }
      }
    );
  }


  // makeAlertRead(){
  //   this.analyticsService.gtag(this.componentName, 'makeAlertRead'); 
  //   // if(this.alerts && this.alerts['Items']){
  //   //   let unreadAlerts = [];
  //   //   for (let i in this.alerts['Items']) {
  //   //     if(this.alerts['Items'][i]['Unread'] == true){  unreadAlerts.push(this.alerts['Items'][i]['ID']); }
  //   //   }
  //   //   if(unreadAlerts.length){
  //   //     debugger;
  //   //     this.dashboardService.makeAlertsRead(this.selectedCard.CardKey, { cardKey: this.selectedCard.CardKey, AlertIds: unreadAlerts}).subscribe(
  //   //       (res)=>{
  //   //         // this.changeUnreadCount(unreadAlerts.length);
  //   //         this.router.navigate(['smione','dashboard','notification']);
  //   //         if(this.selectedCard && this.selectedCard.CardKey){
  //   //           this.getAlerts(this.selectedCard.CardKey);
  //   //         }
  //   //       },
  //   //       (error)=>{
  //   //         console.error(error);
  //   //       },
  //   //     );
  //   //   }else{ this.router.navigate(['smione','dashboard','notification']); }
  //   // }else{ this.router.navigate(['smione','dashboard','notification']); }

  //   this.router.navigate(['smione','dashboard','notification']);

  // }


  makeAlertRead(): void {
    this.analyticsService.gtag(this.componentName, 'makeAlertRead');
    this.closeNotificationDropdown();
    this.router.navigate(['smione', 'dashboard', 'notification']);
  }

  onHeaderAlertClick(event: Event): void {
    event.stopPropagation();
    const href = this.getClickedAlertHref(event);
    if (!href) {
      event.preventDefault();
      this.makeAlertRead();
      return;
    }

    const hrefKey = href.replace(/^\/+/, '').toUpperCase();
    const routeConfig = this.hrefRouteMap[hrefKey];

    if (routeConfig) {
      event.preventDefault();
      this.closeNotificationDropdown();
      localStorage.setItem('pathName', routeConfig.pathName);
      this.router.navigateByUrl(routeConfig.route);
      return;
    }

    event.preventDefault();
    this.makeAlertRead();
  }

  private getClickedAlertHref(event: Event): string {
    const target = event.target as HTMLElement;
    const anchor = target.closest('a[href]') as HTMLAnchorElement;
    if (anchor) {
      return anchor.getAttribute('href') || '';
    }

    return '';
  }


  /** Close the notification dropdown when navigating from an item or View more */
  private closeNotificationDropdown(): void {
    const el = this.notifyDropdown?.nativeElement;
    if (!el) return;
    el.classList.remove('show');
    const menu = el.querySelector('.dropdown-menu');
    if (menu) menu.classList.remove('show');
  }


  changeUnreadCount(unreadAlertsCount){
    let alerts = JSON.parse(sessionStorage.getItem("alerts"));
    if(+alerts.UnreadCount){
      alerts.UnreadCount = +alerts.UnreadCount - unreadAlertsCount;
    }
    sessionStorage.setItem("alerts", JSON.stringify(alerts));
    this.restService.isAlertChange.next(true); 
  }

  logout(){
    this.analyticsService.gtag(this.componentName, 'logout');
    this.restService.generateNewIDMLogoutUrl(); 
  }

  showWarings(warnings){
    var url = location.pathname;
    if((url.includes("smione/dashboard")) && (this.selectedCard.WarningShown== undefined || this.selectedCard.WarningShown == false))
    {
      this.getAlertsFromAPI(this.selectedCard.CardKey);
      this.dialog.open(WarningsComponent, {
        disableClose : true,
        data : warnings
      })
      .afterClosed().subscribe(result => {
        if(result){ this.getAlerts(this.selectedCard.CardKey); }
        this.getAlertsFromAPI(this.selectedCard.CardKey);
      });
    }
  }

  naviagteToDashboard(){ 
    this.analyticsService.gtag(this.componentName, 'naviagteToDashboard');
    this.router.navigate(['smione','dashboard']); 
  }

  clickEvent(){
      this.cardsBtn = !this.cardsBtn;       
  }

  goToOldWebsite(event:any)
  { 
    this.analyticsService.gtag(this.componentName, 'goToOldWebsite');          
    event.target.blur();
    return;

    if (this.isPopUpOpen) {
      return;
    }
    this.isPopUpOpen = true;
    const dialogRef = this.dialog.open(OldWebsiteComponent, { 
      disableClose : true,
      data : { Card : this.selectedCard } 
    })  
    .afterClosed().subscribe(result => {  
      this.isPopUpOpen = false;    
     });  
  }

  orderNewCard() { 
    this.router.navigate(['/smione/dashboard/order-new-card']); 
  }

  /** Focus first focusable item when cards menu opens */
  focusFirstCardsMenuItem(): void {
    setTimeout(() => {
      const cardsMenu = document.querySelector('.mat-menu-panel .cardsMenu') as HTMLElement;
      if (cardsMenu) {
        const items = this.getCardsMenuFocusableItems(cardsMenu);
        if (items.length > 0) {
          items[0].focus();
        }
      }
    }, 0);
  }


  /** Get focusable menu items in DOM order: card rows then "Add new card" */
  private getCardsMenuFocusableItems(container: HTMLElement): HTMLElement[] {
    const list = container.querySelectorAll<HTMLElement>('.cards-main .cardslist, .last-menu');
    return Array.from(list);
  }


  /** Handle ArrowDown on trigger: open menu so menuOpened can focus first item */
  onCardsTriggerKeydown(event: KeyboardEvent): void {
    if (event.key === 'ArrowDown' && this.matMenuTrigger && !this.matMenuTrigger.menuOpen) {
      event.preventDefault();
      this.matMenuTrigger.openMenu();
    }
  }


  /** Handle Escape (close), ArrowDown (next), ArrowUp (prev) inside cards menu */
  cardsMenuKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      if (this.matMenuTrigger) {
        this.matMenuTrigger.closeMenu();
      }
      return;
    }


    const container = event.currentTarget as HTMLElement;
    if (!container || !container.classList.contains('cardsMenu')) return;


    const items = this.getCardsMenuFocusableItems(container);
    if (items.length === 0) return;


    const currentIndex = items.indexOf(document.activeElement as HTMLElement);


    if (event.key === 'ArrowDown') {
      event.preventDefault();
      const nextIndex = currentIndex < 0 ? 0 : (currentIndex + 1) % items.length;
      const nextEl = items[nextIndex];
      setTimeout(() => nextEl.focus(), 0);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      const prevIndex = currentIndex <= 0 ? items.length - 1 : currentIndex - 1;
      const prevEl = items[prevIndex];
      setTimeout(() => prevEl.focus(), 0);
    }
  }

  
}
